import { DiceType } from './DiceModel';
import { t } from '../i18n';

export interface DiceSet {
  id: string;
  nameKey: string;
  descKey: string;
  dices: DiceType[];
  isHidden?: boolean;
}

// Helper to get translated name/desc
export const getDiceSetName = (diceSet: DiceSet): string => t(diceSet.nameKey);
export const getDiceSetDesc = (diceSet: DiceSet): string => t(diceSet.descKey);

export const DICE_SETS: DiceSet[] = [
  {
    id: 'cavier-set',
    nameKey: 'diceSet.cavier-set.name',
    descKey: 'diceSet.cavier-set.desc',
    dices: [DiceType.CAVIER_1, DiceType.CAVIER_2, DiceType.CAVIER_3, DiceType.CAVIER_4, DiceType.CAVIER_5, DiceType.CAVIER_6],
    isHidden: true
  },
  {
    id: 'odd-set',
    nameKey: 'diceSet.odd-set.name',
    descKey: 'diceSet.odd-set.desc',
    dices: [DiceType.ODD, DiceType.ODD, DiceType.ODD, DiceType.ODD, DiceType.ODD, DiceType.ODD],
    isHidden: false
  },
  {
    id: 'even-set',
    nameKey: 'diceSet.even-set.name',
    descKey: 'diceSet.even-set.desc',
    dices: [DiceType.EVEN, DiceType.EVEN, DiceType.EVEN, DiceType.EVEN, DiceType.EVEN, DiceType.EVEN],
    isHidden: false
  },
  {
    id: 'mini-set',
    nameKey: 'diceSet.mini-set.name',
    descKey: 'diceSet.mini-set.desc',
    dices: [DiceType.MINI, DiceType.MINI, DiceType.MINI],
    isHidden: false
  },
  {
    id: 'clothed-set',
    nameKey: 'diceSet.clothed-set.name',
    descKey: 'diceSet.clothed-set.desc',
    dices: [DiceType.CLOTHED, DiceType.CLOTHED, DiceType.CLOTHED, DiceType.CLOTHED, DiceType.CLOTHED, DiceType.CLOTHED],
    isHidden: false
  },
  {
    id: 'rigged-set',
    nameKey: 'diceSet.rigged-set.name',
    descKey: 'diceSet.rigged-set.desc',
    dices: [DiceType.RIGGED, DiceType.RIGGED, DiceType.RIGGED, DiceType.RIGGED, DiceType.RIGGED, DiceType.RIGGED],
    isHidden: false
  },
  {
    id: 'lucky-set',
    nameKey: 'diceSet.lucky-set.name',
    descKey: 'diceSet.lucky-set.desc',
    dices: [DiceType.SMALL_LUCKY, DiceType.SMALL_LUCKY, DiceType.SMALL_LUCKY, DiceType.LUCKY, DiceType.LUCKY, DiceType.LUCKY],
    isHidden: true
  },
  {
    id: 'gambler-set',
    nameKey: 'diceSet.gambler-set.name',
    descKey: 'diceSet.gambler-set.desc',
    dices: [DiceType.ANGEL_AN, DiceType.ANGEL_JI, DiceType.ANGEL_LA, DiceType.DEMON_LU, DiceType.DEMON_XI, DiceType.DEMON_FA],
    isHidden: false
  },
  {
    id: 'triple-three-set',
    nameKey: 'diceSet.triple-three-set.name',
    descKey: 'diceSet.triple-three-set.desc',
    dices: [DiceType.ANTIOCH, DiceType.ANTIOCH, DiceType.ANTIOCH, DiceType.TRIPLE_THREE, DiceType.TRIPLE_THREE, DiceType.TRIPLE_THREE],
    isHidden: false
  },
  {
    id: 'loaded-set',
    nameKey: 'diceSet.loaded-set.name',
    descKey: 'diceSet.loaded-set.desc',
    dices: [DiceType.LOADED],
    isHidden: true
  },
  {
    id: 'heaven-knight-set',
    nameKey: 'diceSet.heaven-knight-set.name',
    descKey: 'diceSet.heaven-knight-set.desc',
    dices: [DiceType.HEAVEN, DiceType.KNIGHT, DiceType.KNIGHT, DiceType.KNIGHT, DiceType.KNIGHT, DiceType.KNIGHT],
    isHidden: true
  },
  {
    id: 'adult-set',
    nameKey: 'diceSet.adult-set.name',
    descKey: 'diceSet.adult-set.desc',
    dices: [DiceType.ADULT, DiceType.ADULT, DiceType.ADULT, DiceType.ADULT, DiceType.ADULT, DiceType.ADULT],
    isHidden: true
  },
  {
    id: 'low-set',
    nameKey: 'diceSet.low-set.name',
    descKey: 'diceSet.low-set.desc',
    dices: [DiceType.UNLUCKY, DiceType.CAVI_C, DiceType.UNPOPULAR],
    isHidden: true
  }
];
